define [], () ->
  ($scope, $rootScope, $state, $stateParams, RentappService, RENTAPPLICATION_API_URL, Flash, hotkeys, $http, $window) ->
    $scope.secure_svg = require('./../secure.svg')

    $scope.context =  $stateParams.context
    $scope.application = $stateParams.application
    $scope.questions = $stateParams.questions

    $scope.vendor_name = if $stateParams.vendor == 'smartmove' then 'Transunion' else 'Experian'
    if $scope.context == 'landlord' and $scope.vendor_name == 'Transunion'
      $scope.questions = require('./smartmove_questions.coffee')
      $scope.landlord_data = $stateParams.landlord_data

    $scope.reset_questions = () ->
      $scope.current_question_index = 1
      $scope.answers = []
      $scope.current_question = $scope.questions[0]
      $scope.selected_answer = null
    
    $scope.reset_questions()

    $scope.set_answer = (index) ->
      $scope.selected_answer = index + 1

    $scope.next_question = () ->
      unless $scope.selected_answer?
        Flash.create('danger', "Please select an answer.", 3000)
        $window.scrollTo(0, 0)
        return

      $scope.answers.push($scope.selected_answer)

      if $scope.current_question_index < $scope.questions.length
        $scope.current_question = $scope.questions[$scope.current_question_index]
        $scope.current_question_index += 1
        $scope.selected_answer = null
      else
        $scope.submit_answers()
    
    $scope.smartmove_verify_landlord = () ->
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/reportsourceprofile/smartmove_verify_landlords/",
        answers: $scope.answers.map((answer) -> "#{answer}")
        landlord_data: $scope.landlord_data
      .then (response) ->
        $state.go('root.verifications.verify_success', { context: $scope.context })
      .catch (response) ->
        console.log(response)
      .finally ->
        $scope.submitting_answers = false
    
    $scope.smartmove_answer_questions = () ->
      $http.put "#{RENTAPPLICATION_API_URL}/api/v1/application/#{$stateParams.application_id}/smartmove_answer_applicant_questions/",
        answers: $scope.answers.map((answer) -> "#{answer}")
      .then (response) ->
        if response.data.result == 'partial'
          $scope.questions = response.data.questions
          $scope.reset_questions()
          Flash.create('warning', "You have answered one or more questions incorrectly. That's ok! We just need to ask a few more questions to help us verify your identity.", 6000)
          # TODO: Flash message stating partial pass and need to answer more questions
        else
          if $scope.context == 'applicant-payment'
            $state.go('root.payment.verify.verify_success')
          else
            $state.go('root.applications.verify.verify_success', { application: $scope.application})
      .catch (response) ->
        if $scope.context == 'applicant-payment'
          $state.go('root.payment.verify.verify_fail')
        else
          $state.go('root.applications.verify.verify_fail', { application: $scope.application})
        console.log(response)
      .finally ->
        $scope.submitting_answers = false

    $scope.submit_answers = () ->
      $scope.submitting_answers = true
      if $scope.vendor_name == 'Transunion'
        if $scope.context == 'landlord'
          $scope.smartmove_verify_landlord()
        else
          console.log($scope.answers.map((answer) -> "#{answer}"))
          $scope.smartmove_answer_questions()
      else
        $http.post "#{RENTAPPLICATION_API_URL}/api/v1/reportsourceprofile/experian_questions/?#{$scope.context}=true",
          answers: $scope.answers.map((answer) -> "#{answer}")
          application_id: $stateParams.application_id
        .then (response) ->
          if $scope.context == 'landlord'
            $state.go('root.verifications.verify_success', { context: $scope.context })
          else if $scope.context == 'applicant-payment'
            $state.go('root.payment.verify.verify_success')
          else
            $state.go('root.applications.verify.verify_success', { application: $scope.application})
        .catch (response) ->
          if $scope.context == 'landlord'
            $state.go('root.verifications.verify_fail', { context: $scope.context })
          else if $scope.context == 'applicant-payment'
            $state.go('root.payment.verify.verify_fail')
          else
            $state.go('root.applications.verify.verify_fail', { application: $scope.application})
        .finally -> $scope.submitting_answers = false



// WEBPACK FOOTER //
// ./components/verifications/questions/questions.coffee